import './ModelConfigCard.scss';

interface ModelConfigEnvironment {
  environment_name: string;
}

interface ModelConfigCardConfig {
  name?: string;
  environments?: ModelConfigEnvironment[];
}

interface ModelConfigCardProps {
  config: ModelConfigCardConfig | null;
  selected: boolean;
  onSelect: () => void;
}

function ModelConfigCard({ config, selected, onSelect }: ModelConfigCardProps) {
  const environments = config?.environments || [];
  const envNames = environments.map((env) => env.environment_name);
  const firstTwo = envNames.slice(0, 2);
  const remaining = envNames.length - 2;
  const displayText = remaining > 0
    ? `${firstTwo.join(', ')} (+${remaining})`
    : firstTwo.join(', ');

  return (
    <button
      type="button"
      className={`model-config-card${selected ? ' model-config-card--selected' : ''}`}
      onClick={onSelect}
      data-testid={`select-model-configuration-${config?.name || ''}`}
    >
      <div className="model-config-card__name">
        {config?.name || ''}
      </div>
      {envNames.length > 0 && (
        <div className="model-config-card__description">
          {displayText}
        </div>
      )}
    </button>
  );
}

ModelConfigCard.defaultProps = {};

export default ModelConfigCard;
